export type LiveClassConfig = {
  id: string;
  label: string;
  dayOfWeek: number; // 0=Sun, 1=Mon, 2=Tue, 3=Wed, 4=Thu, 5=Fri, 6=Sat
  hour: number;
  minute: number;
  durationMinutes: number;
  preActiveMinutes: number;
  zoomLink: string;
  cohortIds?: number[];
  educationTypes?: string[];
};

export const LIVE_CLASSES: LiveClassConfig[] = [
  {
    id: "ds-weekly",
    label: "Data Science Canlı Ders",
    dayOfWeek: 4,
    hour: 19,
    minute: 30,
    durationMinutes: 90,
    preActiveMinutes: 15,
    zoomLink:
      "https://us06web.zoom.us/j/81612149732?pwd=kePlS89lpXUdddtlyNwptOCuifrO3S.1",
    cohortIds: [265, 268, 298, 331, 334, 336, 340, 365, 437],
  },
  {
    id: "fs-weekly",
    label: "Fullstack Canlı Ders",
    dayOfWeek: 3,
    hour: 19,
    minute: 30,
    durationMinutes: 90,
    preActiveMinutes: 15,
    zoomLink:
      "https://us06web.zoom.us/j/89444188214?pwd=aICFobzbs03ghjAtsHbpCB7v6kQrjr.1",
    cohortIds: [267, 332, 337, 338, 364, 438],
  },
  {
    id: "ds-demo",
    label: "Demo Ders",
    dayOfWeek: 2,
    hour: 16,
    minute: 0,
    durationMinutes: 90,
    preActiveMinutes: 15,
    zoomLink:
      "https://us06web.zoom.us/j/89556793299?pwd=HfEeMzmtsdih5JDX1qWEA7G38pvkoa.1",
    cohortIds: [331],
  },
];
